import { useWeb3 } from '@/hooks/use-web3';
import { RootState } from '@/store/reducers';
import { EvmTxHistory, ResGetPoolDetailsCall, ResGetStakeCall } from '@/types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PortfolioCard from './card/PortfolioCard';
import { Box, Typography, useTheme } from '@mui/material';
import { GETSTAKE } from '@/lib/common/name-space';

type AddEvmTxHistory = EvmTxHistory &
  ResGetPoolDetailsCall & {
    state: string;
    amountStaked: string;
  };
export default function Holdings({ aList, aAddress }: { aList: EvmTxHistory[] | null; aAddress: string }) {
  const { web3authCall } = useWeb3();
  const poolInfo = useSelector((state: RootState) => state.poolInfo);
  const [list, setList] = useState<AddEvmTxHistory[] | null>(null);
  const navigate = useNavigate();
  const theme = useTheme();

  // const [wallet, setWallet] = useRecoilState(walletState);
  useEffect(() => {
    if (!aList) {
      return;
    }
    if (list) {
      return;
    }
    (async () => {
      if (web3authCall?.connected()) {
        // 풀을 가져옴
        const pools: string[] = await web3authCall.getStakingCall().getAllPools();
        // 사용자 트랜잭션에 있는 stakeToken과 pools(컨트랙트아이디가 있는지) 체크 후 따로 컨트랙트 가져옴

        // const re: EvmTxHistory[] = await evmTxHistoryList(addr);
        // if (!re?.length) {
        //   return;
        // }

        await setHoldList(aList, pools);
      }
    })();
    return () => {};
  }, [web3authCall, poolInfo, aList]);

  const setHoldList = async (aList: EvmTxHistory[], aPools: string[]) => {
    const seen = new Set();

    const filter = aList.filter((item: EvmTxHistory) => {
      if (item.isError === '0' && item.functionName.startsWith('stakeToken')) {
        const temp = item.to;
        return seen.has(temp) ? false : seen.add(temp);
      }
      return false;
    });
    const arr = [];
    for (const iterator of aPools) {
      for (let i = 0; i < filter.length; i++) {
        const iter = filter[i];

        if (iter.to.toLowerCase() === iterator.toLowerCase()) {
          const re = await web3authCall!.getStakingCall().state(iterator);
          const res = await web3authCall!.getStakingCall().getPoolDetails(iterator);
          const stateDetail: ResGetStakeCall = await web3authCall!.callStaking(GETSTAKE, iter.to, [
            iter.from,
            String(i),
          ]);
          const obj = {
            ...iter,
            state: re,
            ...res,
            contractAddr: iter.to,
            amountStaked: stateDetail.amountStaked,
          };
          arr.push(obj);
        }
      }
    }
    setList(arr);
  };
  return (
    <>
      {aAddress ? (
        <Box
          sx={{
            padding: { xs: '16px 24px', md: '20px 24px' },
            maxWidth: '1680px',
          }}
        >
          <Box>
            <Typography color={theme.greyscale.darkgrey2} variant={'h3'}>
              Holdings
            </Typography>
          </Box>
          <Box
            sx={{
              paddingTop: '16px',
              display: 'flex',
              flexDirection: 'column',
              gap: {
                xs: '16px',
                md: '10px',
              },
            }}
          >
            {list &&
              list.map((pool) => (
                <PortfolioCard
                  key={pool.name}
                  name={pool.name}
                  description={pool.description}
                  stakeAmount={pool.amountStaked}
                  APR={pool.annualInterestMultipliedRate}
                  state={pool.state}
                  contractAddr={pool!.contractAddr}
                  address={aAddress}
                />
              ))}
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            maxWidth: '1680px',
            marginTop: '24px',
            padding: { xs: '16px 24px', md: '20px 24px' },
          }}
        >
          <Typography variant="h3" color={theme.greyscale.darkgrey2}>
            Holdings
          </Typography>
          <Box
            sx={{
              marginTop: '24px',
              background: '#357AFF1A',
              borderRadius: '10px',
              padding: '10px',
              textAlign: 'center',
            }}
          >
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              No holdings displayed yet
            </Typography>
          </Box>
        </Box>
      )}
      {/* {list
        ? list.map((item: AddEvmTxHistory, index: number) => (
            <Fragment key={item.hash}>
              Pool Name:{item.name} <br />
              State Amount: {item.minFundraisingPrice} USDT <br />
              Status: {StateFilter(item.state)}
              <Button
                onClick={() => {
                  navigate('/stakeDetail', {
                    state: {
                      contractAddr: item.contractAddr,
                    },
                  });
                }}
              >
                {StateFilter(item.state)}
              </Button>
            </Fragment>
          ))
        : 'No holdings displayed yet'}
        */}
    </>
  );
}
